export default __webpack_public_path__ + "static/media/Roobert-Medium.68378a71.woff";